module.exports = __webpack_public_path__ + "img/st-icon3.b4a5f2e0.png";